import { Component } from 'react';

import { ErrorMessage } from "@iscr/views/icosm/treatment/components/ErrorMessage";
import ValidationErrors from "@iscr/views/med/Sections/ValidationErrors";
import Alert from "@iscr/views/NUI/Alert";
import { rejectOnResErr } from "@iscr/xAppLib/helpers/rejectOnResErr";
import { useAsyncUpdate } from "@iscr/xAppLib/Hooks/useAsync";
import { BoundComponent, BoundField, FormProvider } from "@iscr/xAppLib/UniForm/FormProvider";

import { Button, Header, Message, Form, Input } from 'semantic-ui-react'

import moment from 'moment'

import obj_diff from '../helpers/obj_diff'

import admin_users_model_base from 'models/admin_users_model_base'
import user_model from 'models/user_model'

import {ViewEditDets} from '../DataList'
import trim_object_spaces from '../helpers/trim_object_spaces';
import HeidiToggle from './HeidiToggle';
import {MimsEnrollment} from "@iscr/mims/components/MimsEnrollment";

/**
 * @deprecated This component will be removed in the near future in favour of AdminUsers/EditUser.tsx
 */
export default class AdminUserLegacy_profile extends Component {

	constructor(props) {
		super(props);

		user_model.limit_access('user_admin')

		this.state = {
				iniemail: props.user.email,
				ininame: props.user.displayName,
				newemail: props.user.email,
				newname: props.user.displayName,
				password: '',
				message: '',
				cred:props.user.meta?.cred || '',
				loading: false,
				error: false
			};
	}

	// 		--------------------------------		--------------------------------		---------

	static getDerivedStateFromProps(nextProps, prevState) {
		return {
				newemail: nextProps.user.email==prevState.iniemail ? prevState.newemail : nextProps.user.email,
				newname: nextProps.user.displayName==prevState.ininame ? prevState.newname : nextProps.user.displayName,
			}
	}

	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------

	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------

	async save_dets (delta, ca) {
		const {
			registration_type,
			qualifications,
			ahpra,
			...rest
		} = delta;
		const d = trim_object_spaces({
			...rest,
			...(('registration_type' in delta || 'qualifications' in delta || 'ahpra' in delta) && {
			   xtra: {
				  ...delta.xtra,
				  ...('registration_type' in delta && { registration_type }),
				  ...('qualifications' in delta && { qualifications }),
				  ...('ahpra' in delta && { ahpra }),
			   }
			}),
		});

		const { user, onChange } = this.props

		const prof_diff = obj_diff(user, d)

		console.log('AdminUser_profile :: save_dets', user.uid, prof_diff, Object.keys(prof_diff).length)

		// med_model.update_record( med_code, d )

		// this.setState({det_mode: 'view'})
		if (!prof_diff.to || !Object.keys(prof_diff.to).length) 			return

		this.setState({
						message:'',
						error:false,
						loading:true
					})

		let params = {uid:user.uid, prof_diff:prof_diff}

		if (prof_diff.to.first_name || prof_diff.to.last_name)
			params.newname = (prof_diff.to.first_name || user.first_name) + ' ' + (prof_diff.to.last_name || user.last_name)

		await admin_users_model_base.upd_user_prof( params,  
			result => {
				console.log("result = %o", result)
				this.setState({
								newname: '',
								message: result.res=='ok' && 'New profile set' || result.err_msg,
								error: result.res != 'ok',
								loading: false
							})
			} )

		ca && ca()
		onChange && onChange(d)
	}

	// 		--------------------------------		--------------------------------		---------

	async save_dets_fld (f, d, ca) {

		const { user, onChange } = this.props

		console.log('AdminUser_profile :: save_dets_fld', f, d, user.uid, user)

		await this.save_dets({[f]: d}, ca)
		// med_model.update_record( med_code, { [f]: d } )

		ca && ca()
		onChange && onChange(d)
	}

	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------

	setNewEmail = async () => {
		const { user, onChange } = this.props
		let { newemail } = this.state

		newemail = newemail.trim().replace(/[\u200B-\u200D\uFEFF]/g, '');
		if (newemail==user.email || !newemail) 			return

		console.log("sending newemail %o to user %o", newemail, user)

		this.setState({
						message:'',
						error:false,
						loading:true
					})

		await admin_users_model_base.set_user_newemail( user, newemail, 
			result => {
				console.log("result = %o", result)
				this.setState({
								newemail: '',
								message: result.res=='ok' && 'New email set' || result.err_msg,
								error: result.res != 'ok',
								loading: false
							})
			} )
		onChange && onChange()
	}


	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------

	sendPassword = () => {
		const { user } = this.props
		const { password } = this.state

		if (password == '') 			return

		console.log("sending password %o to user %o",password,user)

		this.setState({
						message:'',
						error:false,
						loading:true
					})

		admin_users_model_base.send_user_password( user, password, 
			result => {
				console.log("result = %o",result)
				this.setState({
								password: '',
								message: result.res=='ok' && 'New password sent' || result.err_msg,
								error: result.res != 'ok',
								loading: false
							})
			} )
	}

	unlinkProfile = async ( uid, pid ) => {
		const { user, onChange } = this.props

		const r = await user_model.unlink_prof({uid, pid})
		this.setState({
			message: r.res==='ok' && 'Family Profile removed' || r.err_msg,
			error: r.res !== 'ok',
			loading: false
		});

		onChange && onChange(user);
	}

	handleOnChange(name, value) {
		if (name === 'cons_has_allergies' && value === 'no') {
			return { cons_allergy: '' };
		}
		if (name === 'cons_has_meds') {
			return { cons_meds: value || '' };
		} 
		if (name === 'cons_has_medhist') {
			return { cons_medhist: value || '' };
		}
	}

	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------

	render() {
		const { user } = this.props
		const { password, newname, newemail, message, error, loading, cred } = this.state
		
		const {
			registration_type,
			qualifications,
			ahpra,
		} = user.xtra || {};

		const data = {
			...user,
			registration_type,
			qualifications,
			ahpra,
			cons_has_meds: user.cons_meds === 'no' && 'no',
			cons_has_medhist: user.cons_medhist === 'no' && 'no',
		};

		if (!data.full_address)
			data.full_address = data.address

		data.dob = data.dob && moment(data.dob).format("YYYY-MM-DD")

		return <div style={{width: '600px'}}>

			<h2>Edit user profile details for user <br/> {user.displayName} <b>{user.email}</b></h2>

				{message && 
					<Message negative={error} positive={!error}>
						<p>{message}</p>
					</Message>
				}

			<hr />
			<br />

			<Form loading={loading} autoComplete="off">

				<Header as="h3">Set and Send new password</Header>

				<Form.Input
					label="New password"
					fluid
					placeholder='Password'
					value={password} 
					onChange={(e,{value})=>this.setState({password:value})}  
					type='text' 
				/>

				<Button type='submit' disabled={password==''} onClick={this.sendPassword} >Submit</Button>

			<br />
			<br />
			<hr />

				<Header as="h3">User profile</Header>

				<h2>Details</h2>
				<ViewEditDets 
						size='mini'
						itm_data = {data} 
						det_fields = {app.user?.claims?.admin ? user_model.PROF_FIELDS_ADMIN : user_model.PROF_FIELDS_MANG}
						// onSave_dets = { (d, ca) => console.log('AdminUser_profile :: onSave_dets', 'obj_diff', obj_diff(user, d) ) }
						// onSave_dets_fld = { (f, d, ca) => console.log('AdminUser_profile :: onSave_dets_fld', f, d, ca) }
						onSave_dets = { (d, ca) => this.save_dets(d, ca) }
						onSave_dets_fld = { (f, d, ca) => this.save_dets_fld(f, d, ca) }
						onChange={this.handleOnChange}
						display_errors
					/>

            <HeidiToggle data={data} updateProfile={this.save_dets_fld.bind(this)} />

			<MimsEnrollment user={user} onEnrolled={() => this.props.onChange?.()} />

			{data.prof?.par && <>
			<br />
			<br />
			<hr />
			<Header as="h3">Unlink this family profile</Header>
			<Button
				//basic
				color="red"
				size="small"
				onClick={async () => await app.confirm(`Unlink family profile?`, `Are you sure you want to unlink ${data.prof?.desc || "this child profile"} from the main familly profile? The child profile will also be marked as disabled.` ) === 'yes' && this.unlinkProfile(data.uid, data.prof.par) }
			>
				Unlink
			</Button>
			</>}
			<br />
			<br />
			<hr />

				<Header as="h3">Change email. Login details will change!</Header>

				<Form.Field>
					<label>New email</label>

					<Input 
							// icon='lock' 
							// iconPosition='left' 
							fluid 
							placeholder={user.email}  
							// name='name' 
							value={newemail} 
							onChange={(e,{value})=>this.setState({newemail:value})}  
							type='text' 
						/>
				</Form.Field>

				<Button 
						type='submit' 
						disabled={newemail==user.email || !newemail} 
						onClick={this.setNewEmail} 
						content='Set login email'
					/>

			<br />
			<br />
			<hr />

			</Form>

			<SetAccountCredit user={user} onSaved={this.props.onChange}/>
		</div>
	}

}

const SET_ACCOUNT_CREDIT_FIELDS = [
	{
		name: 'cred',
		label: 'Amount',
		placeholder: 'Enter amount',
		no_empty: true,
		validate_function: (cred) => cred !== '' && +cred >= 0,
		errors: () => 'Enter a valid amount',
		value: '',
	},
];

function SetAccountCredit({ user, onSaved }) {
	const initialValues = { cred: String(user.meta?.cred || '') };
	const saveCredit = useAsyncUpdate(async ({ cred }) => {
		const result = await admin_users_model_base.set_cred(user, cred).then(rejectOnResErr);
		onSaved?.();
		return result;
	});

	return (
		<FormProvider onSubmit={saveCredit.fn} fields={SET_ACCOUNT_CREDIT_FIELDS} initialValues={initialValues}>
			<Header as="h3">Account Credit</Header>

			<BoundField name="cred" />

			<BoundComponent as={ValidationErrors} />
			<BoundComponent as={ErrorMessage} />

			<Alert visible={saveCredit.data?.res === "ok"} success>
				Saved
			</Alert>

			<BoundComponent as={Button} disabled={saveCredit.loading} loading={saveCredit.loading}>
				Set user credit
			</BoundComponent>
		</FormProvider>
	);
}
